import * as React from 'react'
import {FlexGrowContent, RowFlexContainer, TopRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Close} from '@mui/icons-material'
import {Colors, FontSize} from '../../../../../styledComponents/Constants'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import styled from 'styled-components'
import {
    DialogCloseButton,
    DialogTitle,
    DialogTitleArea,
    DisplayItemDividerDialog,
    FacilityName,
    MainArea,
    PanelArea,
} from '../../common/NatResidentAssocWorkReportsCommon'
import {Box} from '@mui/material'
import moment from 'moment'
import {Report} from '../../repository/NatGetAssocWorkReportPlanResults'
import {PLAN_EXISTENCE} from '../../../../../CodeMaster'
import {NatResidentMergedReportFileComponent} from '../NatResidentMergedReportFileComponent'

interface Props {
    currentMoment: moment.Moment
    accountingTermName: string
    businessName: string
    workingCd: string
    stopYearMonth?: string
    implementationTimes?: string
    businessType?: string
    implementationSubcontractor?: string
    publishInfo?: string
    report?: Report[]
    onMergedFileByWorkingCdClick: (targetWorkingCd: string) => Promise<void>
    onCancel: () => void
}

export const NatBusinessDetailDialog: React.FC<Props> = props => {
    const {
        currentMoment,
        accountingTermName,
        businessName,
        workingCd,
        stopYearMonth,
        implementationTimes,
        businessType,
        implementationSubcontractor,
        publishInfo,
        report,
        onMergedFileByWorkingCdClick,
        onCancel,
    } = props

    const displayItem = (item?: string): string => {
        return item ? item : 'ー'
    }

    const mergedFileName = `${accountingTermName}${businessName}_${currentMoment.format('YYYYMMDD')}.pdf`

    const stopMoment = stopYearMonth ? moment(stopYearMonth, 'YYYYMM').startOf('month') : null
    const reports = (report ?? []).filter(reportItem => {
        if (!reportItem.planResult && reportItem.planExistence !== PLAN_EXISTENCE.HAVE.value) {
            return false
        }

        if (stopMoment) {
            const targetMoment = moment(reportItem.targetYearMonth, 'YYYYMM').startOf('month')
            if (targetMoment.isSameOrAfter(stopMoment)) {
                return false
            }
        }
        return true
    })
    const resultFilesFlatMap = reports.flatMap(reportItem => reportItem.resultFiles)
    const hasFile = resultFilesFlatMap.length > 0
    const totalFileSizeKB = resultFilesFlatMap
        .reduce((sum, resultFile) => sum + Number(resultFile.fileSizeKB), 0)

    return (<>
        <PanelArea>
            <DialogTitleArea>
                <RowFlexContainer>
                    <DialogTitle>業務詳細</DialogTitle>
                    <DialogCloseButton onClick={onCancel} id={'close'}>
                        <Close fontSize={'large'} style={{color: `${Colors.AccentDark}`}}/>
                    </DialogCloseButton>
                </RowFlexContainer>
            </DialogTitleArea>
            <DisplayItemDividerDialog/>
            <MainArea>
                <BlockSpacer height={'20px'}/>
                <FacilityName>{businessName}</FacilityName>
                <BlockSpacer height={'15px'}/>
                <TopRowFlexContainer>
                    <ItemName>実施回数</ItemName>
                    <Item>{displayItem(implementationTimes)}</Item>
                </TopRowFlexContainer>
                <TopRowFlexContainer>
                    <ItemName>契約形態</ItemName>
                    <Item>{displayItem(businessType)}</Item>
                </TopRowFlexContainer>
                <TopRowFlexContainer>
                    <ItemName>実施業者</ItemName>
                    <Item>{displayItem(implementationSubcontractor)}</Item>
                </TopRowFlexContainer>
                <TopRowFlexContainer>
                    <ItemName>備考</ItemName>
                    <Item>{displayItem(publishInfo)}</Item>
                </TopRowFlexContainer>
            </MainArea>
            {hasFile &&
                <>
                    <Box height={'15px'}/>
                    <DisplayItemDividerDialog/>
                    <NatResidentMergedReportFileComponent
                        mergeFileType={`${accountingTermName}の報告書`}
                        currentMoment={currentMoment}
                        onMergedFileClick={() => onMergedFileByWorkingCdClick(workingCd)}
                        totalFileSizeKB={totalFileSizeKB}
                        mergedFileName={mergedFileName}
                    />
                </>
            }
            <FlexGrowContent/>
        </PanelArea>
    </>)
}

const ItemName = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.AccentDark};
  flex-basis: 56px;
  flex-shrink: 0;
  padding-top: 5px
`

const Item = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.Body};
  flex-grow: 1;
  padding-top: 5px;
  padding-left: 15px;
`
